export const GET_NOTIFICAR_A_PARTIDO_LOADING = 'notificarPartido/GET_NOTIFICAR_A_PARTIDO_LOADING';
export const GET_NOTIFICAR_A_PARTIDO_SUCCESS = 'notificarPartido/GET_NOTIFICAR_A_PARTIDO_SUCCESS';
export const GET_NOTIFICAR_A_PARTIDO_FAILURE = 'notificarPartido/GET_NOTIFICAR_A_PARTIDO_FAILURE';
